import React from 'react'
import './index.css'
import { QueryClient, QueryClientProvider } from 'react-query'
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { createTheme, ThemeProvider } from '@mui/material/styles'
import { SnackbarProvider } from 'notistack'
import { NexenExchangeForm } from './screens/NexenExchangeForm'
import { StoreLocator } from './screens/StoreLocator'
import { TNGCampaignForm } from './screens/TNGCampaign/Form'
import { TNGInstruction } from './screens/TNGCampaign/Instruction'
import { RoadHazardWarranty } from './screens/RoadHazardWarranty'
import { RHWarrantyForm } from './screens/RoadHazardWarranty/Form'

const queryClient = new QueryClient()

const theme = createTheme({
  palette: {
    primary: {
      main: '#000',
    },
    secondary: {
      main: '#fff',
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
  },
  fontFamily: 'Nato Sans',
  h1: {
    fontSize: '30px',
    fontWeight: '500',
    fontFamily: 'Nato Sans Bold',
  },
  h2: {
    fontSize: '1.25rem',
    fontWeight: '300',
  },
  h3: {
    fontSize: '18px',
    fontWeight: '200',
  },
  h4: {
    fontSize: '14px',
    fontWeight: '200',
    color: '#767676',
  },
  h5: {
    fontSize: '18px',
    fontWeight: '300',
    color: '#5A5A5A',
  },
  subtitle1: {
    fontSize: '22px',
    fontWeight: '300',
  },
  subtitle2: {
    fontSize: '8px',
    fontWeight: '500',
  },
  button: {
    fontWeight: '1000',
  },
})

const App = () => {
  return (
    <HelmetProvider>
      <SnackbarProvider>
        <Router>
          <QueryClientProvider client={queryClient}>
            <ThemeProvider
              theme={{
                ...theme,
              }}
            >
              <Routes>
                <Route path='/' element={<RoadHazardWarranty />} />
                <Route path='/rhwarranty' element={<RHWarrantyForm />} />
                <Route path='/nexentireexchange' element={<NexenExchangeForm />} />
                <Route path='/nexentiretngcampaign' element={<TNGInstruction />} />
                <Route path='/nexentireregister' element={<TNGCampaignForm />} />
                <Route path='/nexen-center' element={<StoreLocator />} />
                {/* Redirect legacy route to rhwarranty */}
                <Route path='/register' element={<Navigate to='/rhwarranty' />} />
                {/* Catch-all route, redirect back to home on invalid route */}
                <Route path='*' element={<Navigate to='/' replace />} />
              </Routes>
            </ThemeProvider>
          </QueryClientProvider>
        </Router>
      </SnackbarProvider>
    </HelmetProvider>
  )
}

export default App
